import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../common/constants';

const tenantFeature = types.model('tenantFeature', {
  name: types.union(types.string, types.boolean),
  value: types.union(types.string, types.boolean),
  key: types.maybeNull(types.string),
  comment: types.maybeNull(types.string),
  overridden: types.maybeNull(types.string)
});

const TenantFeatureModel = types
  .model('tenantFeatureModel', {
    data: types.optional(types.array(tenantFeature), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_TENANT_FEATURE_DATA, {
        payload
      });
    },
    updateTenantFeature(payload, tenantId) {
      Framework.getEventManager().publish(constants.UPDATE_TENANT_FEATURE_DATA, {
        payload,
        tenantId
      });
    },
    setResponse(response) {
      const finalData = {};
      finalData.data = response.data.map((item) => ({
        ...item,
        overridden: item.tenantId !== '0' ? 'Yes' : 'No'
      }));
      applySnapshot(self, finalData);
      Framework.getEventManager().publish(constants.SET_TENANT_FEATURE_DATA);
    },
    setUpdatedTenantFeature(response) {
      if (response.data.recordsUpserted > 0) {
        const payload = {
          tenantId: response?.config?.headers['x-berlin-tenant-id']
        };
        Framework.getEventManager().publish(constants.GET_TENANT_FEATURE_DATA, {
          payload
        });
      }
    }
  }));

export default TenantFeatureModel;
